import { createContext } from 'react';

export type PropsType = {
  isLoading?: boolean;
  handleLoad: (isLoading: boolean) => void;
};

export const LoaderContext = createContext<PropsType>({
  handleLoad: () => {},
  isLoading: false,
});

export const LoaderContextProvider = LoaderContext.Provider;
